import { labelFor } from "@/lib/labels";
import ImageField from "./ImageField";
import Primitive, { IMAGE_KEYS } from "./Primitive";
import ArrayField from "./ArrayField";
import ObjectField from "./ObjectField";

const SKIP = ["id", "order", "created_at"];

export default function AutoForm({ value, onChange, hideKeys = [] }) {
  if (value == null || typeof value !== "object") return null;
  const setKey = (k, v) => onChange({ ...value, [k]: v });
  const keys = Object.keys(value).filter((k) => !hideKeys.includes(k) && !SKIP.includes(k));

  return (
    <div className="space-y-4">
      {keys.map((k) => {
        const v = value[k];
        if (IMAGE_KEYS.test(k) && (typeof v === "string" || v == null)) {
          return <ImageField key={k} label={labelFor(k)} value={v} onChange={(nv) => setKey(k, nv)} />;
        }
        if (Array.isArray(v)) {
          return <ArrayField key={k} fieldKey={k} value={v} onChange={(nv) => setKey(k, nv)} />;
        }
        if (v && typeof v === "object") {
          return <ObjectField key={k} fieldKey={k} value={v} onChange={(nv) => setKey(k, nv)} />;
        }
        return <Primitive key={k} fieldKey={k} value={v} onChange={(nv) => setKey(k, nv)} />;
      })}
    </div>
  );
}
